import { render, staticRenderFns } from "./ListCheckboxes.vue?vue&type=template&id=181d9420&scoped=true&"
import script from "./ListCheckboxes.vue?vue&type=script&lang=js&"
export * from "./ListCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./ListCheckboxes.vue?vue&type=style&index=0&id=181d9420&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d9420",
  null
  
)

export default component.exports